export default function MenuDivider() {
  return <li className="-mx-3 border-[1px] border-transparent border-t-slate-200 dark:border-t-slate-900/40" />;
}
